import RevxFlexLayout from 'components/RevxFlexLayout';
import { categoryColumns } from '../adjustmentTypes';
import { isSourcer } from 'utils/rbac';
import { Form, FormInstance } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
  JobAdjustmentPrintingCategoryEnum,
  JobAdjustmentPrintingItemViewer,
} from 'domains/workspaceDomain';
import { useUser } from 'hooks';
import { FormListFieldData } from 'antd/lib/form/FormList';
import { RevxButton } from 'components/RevxButton';

type JobAdjustmentPrintingItemsProps = {
  isOriginalPage: boolean;
  isReadjust: boolean;
  canShowEditButton: boolean;
  canEditStatusByRole: () => boolean;
  categoryListForm: FormInstance;
  generateJobAdjustmentCopy: (
    category: boolean,
    categoryType?: JobAdjustmentPrintingCategoryEnum
  ) => Promise<void>;
  addCategory: (
    adjustmentId?: number,
    categoryType?: JobAdjustmentPrintingCategoryEnum
  ) => void;
  addTempCategory?: (
    categoryType?: JobAdjustmentPrintingCategoryEnum
  ) => Promise<void> | void;
  renderCategoryDom: (
    index: number,
    category: JobAdjustmentPrintingItemViewer,
    field: FormListFieldData,
    isShipping: boolean
  ) => JSX.Element;
  categoryItem?: JobAdjustmentPrintingItemViewer[];
  isShipping?: boolean;
};

const JobAdjustmentPrintingItems = ({
  isOriginalPage,
  isReadjust,
  canShowEditButton,
  canEditStatusByRole,
  categoryListForm,
  generateJobAdjustmentCopy,
  addCategory,
  addTempCategory,
  renderCategoryDom,
  categoryItem,
  isShipping,
}: JobAdjustmentPrintingItemsProps) => {
  // console.log('Rendering JobAdjustmentPrintingItems isShipping', isShipping);
  const user = useUser();
  return (
    <RevxFlexLayout className="category-wrap" wrap="wrap">
      {canShowEditButton && (
        <RevxButton
          type="primary"
          className="category-add-btn"
          onClick={async () => {
            console.log('Add line item clicked:', {
              canEditStatusByRole: canEditStatusByRole(),
              hasAddTempCategory: !!addTempCategory,
              isShipping,
            });

            // 总是优先添加临时项，不调用后端接口
            if (addTempCategory) {
              console.log('Adding temp category');
              await addTempCategory();
            } else if (!canEditStatusByRole()) {
              console.log('Calling generateJobAdjustmentCopy');
              await generateJobAdjustmentCopy(true);
            } else {
              console.log('Calling addCategory directly');
              await addCategory();
            }
          }}
          icon={<PlusOutlined />}
        >
          Add line item
        </RevxButton>
      )}
      {((isOriginalPage && isReadjust && categoryItem?.length) ||
        !!categoryItem?.length) && (
        <RevxFlexLayout className={`category-list`}>
          {categoryColumns.map((i, index) => {
            const { key, label, dynamic, flex } = i;
            // 对于 SOURCER 角色，始终跳过 dynamic 字段（Cost 和 Markup）
            // 无论是在 Printing 还是 Shipping 模式下，SOURCER 只需要看到 Total Cost
            const shouldSkip = dynamic && isSourcer(user);

            console.log('Rendering column:', {
              index,
              key,
              label,
              dynamic,
              isSourcer: isSourcer(user),
              isShipping,
              shouldSkip,
            });
            if (shouldSkip) {
              console.log('Skipping column:', { index, key, label });
              return <></>;
            }
            const curLabelMap: { [key: string]: string } = {
              itemName: 'Item name',
              cost: 'Cost',
            };
            const reviewModelLabel = curLabelMap?.[key] || label;
            return (
              <div
                className="category-col"
                key={index}
                style={{
                  flex: isSourcer(user) ? i?.dynamicFlex || flex : flex,
                }}
              >
                <div className="category-col__title">
                  <span>
                    {canEditStatusByRole() ? label : reviewModelLabel}
                  </span>
                </div>
                <Form form={categoryListForm}>
                  <Form.List name="categoryItem">
                    {(fields) => {
                      return fields.map((field) => {
                        if (!categoryItem) {
                          return <div key={field.key}></div>;
                        }
                        const item = categoryItem[field.fieldKey];
                        if (item?.copyFromOldVersion) {
                          return null;
                        }
                        return (
                          <RevxFlexLayout
                            className="category-col__main"
                            key={item?.id}
                          >
                            {renderCategoryDom(
                              index,
                              item,
                              field,
                              isShipping || false
                            )}
                          </RevxFlexLayout>
                        );
                      });
                    }}
                  </Form.List>
                </Form>
              </div>
            );
          })}
        </RevxFlexLayout>
      )}
    </RevxFlexLayout>
  );
};

export default JobAdjustmentPrintingItems;
